import React from "react";
import { Link } from "gatsby";
import { twMerge } from "tailwind-merge";

export type KontentLink = {
  elements: {
    external_url: { value: string };
    internal_path: { value: string };
    open_in_new_window: { value: [{ codename: string }] };
    text: { value: string };
    icon: { value: [{ url: string; width: string; height: string }] };
  };
  system: { type: "link" };
};

interface FooterLinkProps {
  children: React.ReactNode;
  target: string;
  internalPath?: string;
  externalUrl?: string;
  className?: string;
  boldText?: boolean;
}

const FooterLink = ({
  children,
  target,
  internalPath,
  externalUrl,
  className,
  boldText,
}: FooterLinkProps) => {
  const commonClasses = twMerge(
    "flex items-center font-body tracking-wide text-warmWhite hover:underline",
    boldText ? "font-medium" : "font-light",
    className
  );

  if (internalPath) {
    return (
      <Link to={internalPath} target={target} className={commonClasses}>
        {children}
      </Link>
    );
  }

  return (
    <a href={externalUrl} target={target} className={commonClasses}>
      {children}
    </a>
  );
};

export default FooterLink;
